import { render, staticRenderFns } from "./TieredPriceSidebar.vue?vue&type=template&id=3837773c&scoped=true&"
import script from "./TieredPriceSidebar.vue?vue&type=script&lang=js&"
export * from "./TieredPriceSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TieredPriceSidebar.vue?vue&type=style&index=0&id=3837773c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837773c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3837773c')) {
      api.createRecord('3837773c', component.options)
    } else {
      api.reload('3837773c', component.options)
    }
    module.hot.accept("./TieredPriceSidebar.vue?vue&type=template&id=3837773c&scoped=true&", function () {
      api.rerender('3837773c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product/components/TieredPriceSidebar.vue"
export default component.exports